import React from 'react'
import { CartButton, CartButtonCount, CartButtonCountText, MobileCartButtonWrap } from './index.styled'
import ButtonIcon from '../../../../img/svg/button'

const MobileCartButtonBig = React.memo(({ count, onClick }) => {
	return (
		<MobileCartButtonWrap onClick={onClick} data-testid="mobile-cart-btn">
			<CartButton id="mobile-cart-btn">
				<ButtonIcon icon="cart" />
				{count > 0 && <CartButtonCount>
					<CartButtonCountText>
						{count}
					</CartButtonCountText>
				</CartButtonCount>}
			</CartButton>
		</MobileCartButtonWrap>
	)

})

MobileCartButtonBig.displayName = 'MobileCartButtonBig'
export default MobileCartButtonBig
